import api from "../api";
import { getSecureLocalItem } from "utils/secureSessionStorage";
//i will fn for this later
const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Get all plans
export const getPlans = async () => {
  return api.get("/v1/api/plans");
};

// Create a new plan
export const createPlan = async (planData) => {
  return api.post("/v1/api/plans", planData);
};

// Update an existing plan
export const updatePlan = async (planId, planData) => {
  return api.put(`/v1/api/plans/${planId}`, planData);
};
